import { render, staticRenderFns } from "./FreeInsurance.vue?vue&type=template&id=192ee6ef&"
import script from "./FreeInsurance.vue?vue&type=script&lang=js&"
export * from "./FreeInsurance.vue?vue&type=script&lang=js&"
import style0 from "./FreeInsurance.vue?vue&type=style&index=0&id=192ee6ef&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports